import DocumentService from "../services/document.service";
import { GET_DOCUMENT_TYPES, GET_MY_DOCUMENTS } from "./types";

export const getDocument = (id) => (dispatch) => {
  return DocumentService.getFacility(id);
};

export const getDocuments = (filters) => (dispatch) => {
  return DocumentService.getDocuments(filters).then((response) => {
    const { data } = response;

    dispatch({
      type: GET_MY_DOCUMENTS,
      payload: { documents: data },
    });

    return data;
  });
};

export const addDocumentType = (type) => (dispatch) => {
  return DocumentService.addDocumentType(type).then((response) => {
    const { data } = response;
    const { data: docType } = data;

    return docType;
  });
};

export const getDocumentTypes = () => (dispatch) => {
  return DocumentService.getDocumentTypes().then((response) => {
    const { data } = response;
    const { data: docTypes } = data;

    const documentTypes = docTypes.map((item) => {
      return { value: item.id, label: item.name };
    });
    dispatch({
      type: GET_DOCUMENT_TYPES,
      payload: documentTypes,
    });

    return documentTypes;
  });
};

export const uploadDocument = (formData) => (dispatch) => {
  return DocumentService.uploadDocument(formData);
};

export const editDocument = (id, formData) => (dispatch) => {
  return DocumentService.editDocument(id, formData);
};

export const processDocument = (id) => (dispatch) => {
  return DocumentService.processDocument(id).then((response) => {
    const { data } = response;
    const { data: doc } = data;

    return doc;
  });
};

export const deleteDocument = (id) => (dispatch) => {
  return DocumentService.deleteDocument(id);
};
